module.exports = __webpack_public_path__ + "img/download_bg.9a6fce27.png";